import config from 'config';

export const generatePromotionPageUrl = (publicCode: string, term?: string) => {
  return `promotion/${term?.toLowerCase()}/${publicCode.toLowerCase()}`;
};

export const generateActivationPageUrl = (offerCode?: string) => {
  return `${config.shidoUrl}promotion/${offerCode?.toLowerCase()}/activate`;
};
